// extracted by mini-css-extract-plugin
export var askAiIcon = "_nz-j";
export var category = "_nz-9";
export var categoryHeader = "_nz-e";
export var container = "_nz-0";
export var group = "_nz-a";
export var groupItems = "_nz-f";
export var groupSeparator = "_nz-k";
export var loading = "_nz-1";
export var noResults = "_nz-3";
export var placeholder = "_nz-2";
export var resultContent = "_nz-5";
export var resultIcon = "_nz-c";
export var resultItem = "_nz-g";
export var resultMeta = "_nz-8";
export var resultSubtitle = "_nz-7";
export var resultSuffix = "_nz-i";
export var resultTitle = "_nz-6";
export var resultsList = "_nz-4";
export var searchGroup = "_nz-d";
export var selected = "_nz-h";
export var subgroup = "_nz-b";